export var ArrowType;
(function (ArrowType) {
    ArrowType[ArrowType["Left"] = 0] = "Left";
    ArrowType[ArrowType["Right"] = 1] = "Right";
})(ArrowType || (ArrowType = {}));
